import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody, PaginatedBody } from '@/api/types';
import { CreateOpoContactRequestBody, OpoContact } from '@/api/apis/opo/opo.types';
import { getOpobffContactApiUrl } from './opobff-contact.paths';
import { PaginatedOpobffContactListQueryParams, UpdateOpobffContactRequestBody } from './opobff-contact.types';

const getContacts = async (params: PaginatedOpobffContactListQueryParams): Promise<PaginatedBody<OpoContact>> => {
  const res = await http.get<PaginatedApiResponseBody<OpoContact>>(getOpobffContactApiUrl.contacts(), {
    params,
    paramsSerializer: { indexes: null },
  });
  return res.data.data;
};

const getContactByUserId = async (userId: string): Promise<OpoContact> => {
  const res = await http.get<ApiResponseBody<OpoContact>>(getOpobffContactApiUrl.contactByUserId(userId));
  return res.data.data;
};

const getContactById = async (contactId: string): Promise<OpoContact> => {
  const res = await http.get<ApiResponseBody<OpoContact>>(getOpobffContactApiUrl.contactById(contactId));
  return res.data.data;
};

const createContact = async (body: CreateOpoContactRequestBody): Promise<void> => {
  const res = await http.post<ApiResponseBody<void>>(getOpobffContactApiUrl.contacts(), body);
  return res.data.data;
};

const updateContact = async ({
  contactId,
  ...body
}: UpdateOpobffContactRequestBody & { contactId: string }): Promise<void> => {
  const res = await http.patch<ApiResponseBody<void>>(getOpobffContactApiUrl.contactById(contactId), body);
  return res.data.data;
};

const deleteContact = async (contactId: string): Promise<void> => {
  const res = await http.delete<ApiResponseBody<void>>(getOpobffContactApiUrl.contactById(contactId));
  return res.data.data;
};

export const opobffContactApiFetcher = {
  getContacts,
  getContactById,
  getContactByUserId,
  createContact,
  updateContact,
  deleteContact,
};
